module.exports = __webpack_public_path__ + "img/change.6d8ad16d.jpg";